<template>
  <div>
    <div v-if="!text">
      <canvas
        id="myChart38"
        width="30"
        height="10"
      />
    </div>
    <div
      v-else
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardEvolucaoFaturamentoCliente',
    components: {
    },

    data: () => ({
      myChart: {},
      styleCliente: {
        color: '#ed934f',
      },
      enableGrafico: true,
      text: null,
      montaGrafico: true,
      dadosFaturamento: [],
      labels: [],
    }),

    created () {
      eventEmit.$on('set-faturamento-dados-cliente', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-faturamento-dados-cliente', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (dadosFaturamento, labels) {
        this.dadosFaturamento = dadosFaturamento
        this.labels = labels

        this.MontarGrafico()
      },

      MontarGrafico () {
        if (this.myChart.data) {
          this.myChart.destroy()
        }

        const ctx = document.getElementById('myChart38').getContext('2d')

        this.myChart = new Chart(ctx, {
          type: 'line',
          data: {
            labels: this.labels,
            datasets: [
              {
                label: 'Faturamento',
                data: this.dadosFaturamento,
                borderColor: '#4780b8',
                backgroundColor: 'transparent',
                order: 1,
                fill: false,
                tension: 0,
              },
            ],
          },
          options: {
            scales: {
              y: {
                beginAtZero: true,
              },
              xAxes: [{
                gridLines: {
                  display: false,
                },
              }],
              yAxes: [{
                gridLines: {
                  display: false,
                },
                display: false,
              }],
            },
            low: 10,
            high: 5,
            legend: {
              display: false,
            },
            tooltips: {
              callbacks: {
                label: (tooltipItem, data) => {
                  return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                },
              },
            },
          },
        })
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 480px) {

  }
</style>

<style lang="sass">

</style>
